"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Steps = exports.States = exports.kTmpAssignmentStatsFile = exports.kSecondaryTripCancelReason = exports.kDbTripUpdate = exports.kDbTripCreate = exports.kResetTripCheckpoint = exports.kDbError = exports.kVehicleToFleetRpc = exports.kTripFinished = exports.kTripUpdateChannel = exports.kUnreachableVehiclesChannel = exports.kPlanStepProcessed = exports.kVehicleWarningEvent = exports.kVehicleRequestCancelTrip = exports.kVehicleDropoffComplete = exports.kVehiclePickupRider = exports.kVehicleDriverReady = exports.kVehicleRiderReady = exports.kRequestRouteComplete = exports.kRoutingResponse = exports.kRoutingRequest = exports.kRoutePathUpdated = exports.kVehicleReadyToGo = exports.kRideRequestAccepted = exports.kRequestConfirm = exports.kVehicleArrived = exports.kFleetUpdate = exports.kInvalidRequestError = exports.kGlobalConfigUpdated = exports.kVehicleReadinessChange = exports.kVehicleGpsUpdate = exports.kVehicleGpsSubscribe = exports.kVehiclePlanUpdate = exports.kVehicleLogUpdate = exports.kVehicleEvent = exports.kVehicleSetToNotReady = exports.kVehicleSetToReady = exports.kTripCompleted = exports.kTripPlanChange = exports.kTripStateChange = exports.kTripCreate = exports.kTripAssigned = exports.kVehicleStateUpdate = exports.kVehicleServiceRpc = exports.kVehicleConnected = exports.kTaxiApi = exports.kRideosMonitorRun = exports.kRideosMonitorReady = exports.kMonitorStatus = exports.kStoreEta = exports.kGpsPubSub = exports.kSetDbOk = exports.kSetDbFlush = exports.kPing = exports.kEcho = exports.kSetDb = exports.kGetDb = exports.kBinaryMessagePrefix = exports.kRiderClassValues = exports.kRiderClassNames = exports.kPriorityRegular = exports.kPriorityVIP = exports.kPriorityDummy = exports.kRpcSet = exports.kValueStore = exports.kClientStore = exports.kUnregisterChannel = exports.kRegisterChannel = exports.kRpcCmd = exports.kLoginCmd = exports.kPullCmd = exports.kPushCmd = exports.kPushEventErr = exports.kPushEvent = exports.kRedundantLogin = exports.kInvalidAuth = exports.kTargetNotFound = exports.kClientNotConnected = exports.kNotImplemented = exports.kLoginDoneEvent = exports.kUserRole = exports.kServiceRole = exports.kVehicleRole = void 0;
exports.kVehicleRole = "v";
exports.kServiceRole = "s";
exports.kUserRole = "u";
exports.kLoginDoneEvent = "login-done";
exports.kNotImplemented = "not implemented";
exports.kClientNotConnected = "client not connected";
exports.kTargetNotFound = "target not found";
exports.kInvalidAuth = "invalid authentication";
exports.kRedundantLogin = "redundant login";
exports.kPushEvent = "push-event";
exports.kPushEventErr = "push-event/err";
exports.kPushCmd = "push/v1";
exports.kPullCmd = "pull/v1";
exports.kLoginCmd = "login";
exports.kRpcCmd = "rpc";
exports.kRegisterChannel = "register";
exports.kUnregisterChannel = "unregister";
exports.kClientStore = "clients";
exports.kValueStore = "store";
exports.kRpcSet = "$rpcSet";
exports.kPriorityDummy = 4;
exports.kPriorityVIP = 2;
exports.kPriorityRegular = 0;
exports.kRiderClassNames = { [exports.kPriorityVIP]: "VIP", [exports.kPriorityRegular]: "Regular", [exports.kPriorityDummy]: "Dummy" };
exports.kRiderClassValues = { regular: exports.kPriorityRegular, vip: exports.kPriorityVIP, dummy: exports.kPriorityDummy };
exports.kBinaryMessagePrefix = "bin$";
exports.kGetDb = "$getdb";
exports.kSetDb = "$setdb";
exports.kEcho = "$echo";
exports.kPing = "$ping";
// Used to notify when pending set-db logs are flushed to the server.
exports.kSetDbFlush = "$setdb-flush";
exports.kSetDbOk = "$mongo-setdb";
exports.kGpsPubSub = "$gps";
exports.kStoreEta = "$eta";
exports.kMonitorStatus = "$monitor-status";
exports.kRideosMonitorReady = "$rideos-ready";
exports.kRideosMonitorRun = Symbol("$rideos-monitor-run");
exports.kTaxiApi = "$xtaxi-api";
exports.kVehicleConnected = "$connected";
exports.kVehicleServiceRpc = "$vehicle-service";
exports.kVehicleStateUpdate = "vehicleState";
exports.kTripAssigned = "$trip-assigned";
exports.kTripCreate = "$trip-create";
exports.kTripStateChange = "$trip-state-change";
exports.kTripPlanChange = "$trip-plan-change";
exports.kTripCompleted = "$trip-completed";
exports.kVehicleSetToReady = "$setToReady";
exports.kVehicleSetToNotReady = "$setToNotReady";
// Used to notify vehicleEvent update to a worker instance.
exports.kVehicleEvent = Symbol("$vehicle-event");
exports.kVehicleLogUpdate = Symbol("$vehicle-log-update");
exports.kVehiclePlanUpdate = Symbol("$vehicle-plan-update");
exports.kVehicleGpsSubscribe = Symbol("$vehicle-gps-subscribe");
exports.kVehicleGpsUpdate = Symbol("$vehicle-gps-update");
exports.kVehicleReadinessChange = Symbol("$vehicle-readiness-change");
exports.kGlobalConfigUpdated = Symbol("$global-config-updated");
// export const kVehicleStepUpdate = Symbol("$vehicle-step-update");
// Used to notify serviceRegion update to a worker instance.
exports.kInvalidRequestError = "invalid-request";
exports.kFleetUpdate = "FleetUpdate";
// Trip related events used with setDB event triggers
exports.kVehicleArrived = "VehicleArrived";
exports.kRequestConfirm = "RequestConfirm";
exports.kRideRequestAccepted = "RideRequestAccepted";
exports.kVehicleReadyToGo = "VehicleReadyToGo";
exports.kRoutePathUpdated = "RoutePathUpdated";
exports.kRoutingRequest = "RoutingRequest";
exports.kRoutingResponse = "RoutingResponse";
exports.kRequestRouteComplete = "RoutePathResponse";
exports.kVehicleRiderReady = "RiderReady";
exports.kVehicleDriverReady = "DriverReady";
exports.kVehiclePickupRider = "PickUpRider";
exports.kVehicleDropoffComplete = "DropoffCompleted";
exports.kVehicleRequestCancelTrip = "CancelTrip";
exports.kVehicleWarningEvent = "VehicleWarningEvent";
exports.kPlanStepProcessed = "PlanStepProcessed";
exports.kUnreachableVehiclesChannel = "$unreachable";
exports.kTripUpdateChannel = "$trip-update";
exports.kTripFinished = Symbol("$trip-finished");
exports.kVehicleToFleetRpc = "$get-v2f";
exports.kDbError = "$db-error";
exports.kResetTripCheckpoint = "$reset-checkpoint";
exports.kDbTripCreate = Symbol("$db-trip-create");
exports.kDbTripUpdate = Symbol("$db-trip-update");
exports.kSecondaryTripCancelReason = "[SERVER] secondary assignment";
exports.kTmpAssignmentStatsFile = "/tmp/assignmentStats.json";
exports.States = {
    waitingForAssignment: "waitingForAssignment",
    requestingOrder: "requestingOrder",
    drivingToPickup: "drivingToPickup",
    waitingForPickup: "waitingForPickup",
    drivingToDropoff: "drivingToDropoff",
    waitingForDropoff: "waitingForDropoff",
    completed: "completed",
    replaced: "replaced",
    canceled: "canceled",
    invalid: "invalid",
    none: "none"
};
exports.Steps = {
    driveToLocation: "driveToLocation",
    pickupRider: "pickupRider",
    dropoffRider: "dropoffRider",
    unassigned: "unassigned",
    // Extra steps for HybridSupport
    driveToPullover: "driveToPullover",
    driveToParkingArea: "driveToParkingArea"
};
//# sourceMappingURL=const.js.map